import { SearchField } from "$components/search-field";
import { Chip, styled } from "@material-ui/core";
import { PriceableItemOrigin } from "elephant-web/gql";
import { defineMessages, useIntl } from "react-intl";

const FiltersWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
}));

const ChipsRow = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
}));

const FilterChip = styled(Chip)(({ theme }) => ({
  textTransform: "capitalize",
  borderRadius: theme.spacing(0.5),
}));

const messages = defineMessages({
  searchPlaceholder: {
    id: "priceList.filters.search.placeholder",
    defaultMessage: "Search items by name",
  },
});

const ALL_ORIGINS: PriceableItemOrigin[] = [
  PriceableItemOrigin.General,
  PriceableItemOrigin.Inventory,
  PriceableItemOrigin.Investigation,
  PriceableItemOrigin.Procedure,
  PriceableItemOrigin.Custom,
];

type Props = {
  searchTerm: string;
  onSearchTermChange: (next: string) => void;
  selectedOrigins: PriceableItemOrigin[];
  onSelectedOriginsChange: (next: PriceableItemOrigin[]) => void;
};

export const PriceListFilters: FC<Props> = ({
  searchTerm,
  onSearchTermChange,
  selectedOrigins,
  onSelectedOriginsChange,
}) => {
  const { formatMessage } = useIntl();

  const toggleOrigin = (origin: PriceableItemOrigin) => {
    onSelectedOriginsChange(
      selectedOrigins.includes(origin)
        ? selectedOrigins.filter((o) => o !== origin)
        : [...selectedOrigins, origin],
    );
  };

  return (
    <FiltersWrapper>
      <SearchField
        fullWidth
        hideHelper
        value={searchTerm}
        onChange={(event) => onSearchTermChange(event.target.value)}
        onClear={() => onSearchTermChange("")}
        data-testid="priceList.filters.search"
        placeholder={formatMessage(messages.searchPlaceholder)}
      />
      <ChipsRow data-testid="priceList.filters.chips">
        {ALL_ORIGINS.map((origin) => {
          const selected = selectedOrigins.includes(origin);
          return (
            <FilterChip
              key={origin}
              label={origin.toLowerCase()}
              clickable
              color={selected ? "primary" : "default"}
              variant={selected ? "default" : "outlined"}
              onClick={() => toggleOrigin(origin)}
              data-testid={`priceList.filters.chip.${origin}`}
              data-selected={selected ? "true" : "false"}
            />
          );
        })}
      </ChipsRow>
    </FiltersWrapper>
  );
};
